import React, { useReducer } from 'react';
import axios from 'axios';

import { Box, Button, TextField, Paper, LinearProgress } from '@mui/material';

import { toast } from 'react-toastify';

import { apiRoute } from '../../../../../App';

const DivisionForm = (props) => {
    const { handleClose, data, modalType, loading, setLoading, ts, rows, setRows, getRows } = props;

    const initialState = {
        name: modalType === 'add' ? '' : data?.name,
        divisionCode: modalType === 'add' ? '' : data?.divisionCode,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'UPDATE_FIELD':
                return {
                    ...state,
                    [action.field]: action.value,
                    errors: {
                        ...state.errors,
                        [action.field]: action.error,
                    },
                };
            case 'UPDATE_FIELD_ERROR':
                return {
                    ...state,
                    errors: {
                        ...state.errors,
                        [action.field]: action.error,
                    }
                };
            case 'CLEAR_FIELD_ERROR':
                return {
                    ...state,
                    bond: (() => {
                        const updatedErrors = { ...state.errors };
                        delete updatedErrors[action.field];
                        return {
                            ...state,
                            errors: updatedErrors,
                        };
                    }),
                };
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    const handleFieldChange = (field, value) => {
        dispatch({ type: 'UPDATE_FIELD', field, value });
    };

    const fieldValidations = {
        name: {
            errorRequired: 'Division name is required', 
            validation: (value) => !value
        },
        divisionCode: {
            errorRequired: 'Division code is required',
            validation: (value) => !value
        }
    }

    const handleBlur = (field, value) => {
        const fieldInfo = fieldValidations[field];
        let error = null;

        if (fieldInfo) {
            if (!value) {
                error = fieldInfo.errorRequired;
            }
        }
        dispatch({ type: 'UPDATE_FIELD', field, value, error });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if (modalType === 'add') {
            const division = {
                name: state?.name,
                divisionCode: state?.divisionCode
            }

            axios.post(`${apiRoute}/api/DivisionTbls`, division)
                .then((res) => {
                    setRows([...rows, {...res.data, id: res.data.pkDivisionId}])
                    toast.success('Division added successfully!', {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'colored',
                    });
                    handleClose();
                })
                .catch((err) => {
                    toast.error(`Error ${err.response.status} while adding new division!`, {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'colored',
                    });
                    console.log(err, 'Error adding court!');
                })
                .finally(() => { setLoading(false); getRows() })
        } else {
            const division = {
                ...data,
                name: state?.name,
                divisionCode: state?.divisionCode
            }

            axios.put(`${apiRoute}/api/DivisionTbls/${data.id}`, division)
                .then((res) => {
                    const updatedRows = rows.map(row => {
                        if (row.id === data.id) {
                            return { ...row, ...res.data };
                        }
                        return row;
                    });
                    setRows(updatedRows);
                    toast.success('Division updated successfully!', {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'colored',
                    });
                    handleClose();
                })
                .catch((err) => {
                toast.error(`Error ${err.response.status} while updating division!`, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'colored',
                });
                console.log(err, 'Error updating division');
                })
                .finally(() => { setLoading(false); getRows() })
        }
    }

    return (
        <>
            <Paper elevation={10}>
                <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', mb: '2vh', textAlign: 'center' }} elevation={10}>
                    <h1>
                        <strong>
                            {modalType === 'add' ? 'Add Division' : 'Edit Division'}
                        </strong>
                    </h1>
                </Paper>
                <form onSubmit={handleSubmit}>
                    <Box p={1}>
                        <Box width={1} flexWrap="wrap" display="flex">
                            <Box width={1} mt={3} pr={3} flex="1">
                                <TextField
                                    fullWidth
                                    required
                                    sx={ts}
                                    id="name"
                                    label="Division Name"
                                    name="name"
                                    value={state.name}
                                    onChange={(e) => {
                                        handleFieldChange('name', e.target.value);
                                    }}
                                    onBlur={(e) => handleBlur('name', e.target.value)}
                                    helperText={state?.errors?.name}
                                    error={!!state?.errors?.name}
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Box>
                            <Box width={1} mt={3} pr={3} flex="1">
                                <TextField
                                    fullWidth
                                    required
                                    sx={ts}
                                    id="divisionCode"
                                    label="Division Code"
                                    name="divisionCode"
                                    value={state.divisionCode}
                                    onChange={(e) => {
                                        handleFieldChange('divisionCode', e.target.value);
                                    }}
                                    onBlur={(e) => handleBlur('divisionCode', e.target.value)}
                                    helperText={state?.errors?.divisionCode}
                                    error={!!state?.errors?.divisionCode}
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="right" gap={2} p={1}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: 'steelblue',
                                color: 'white',
                                mt: '2vh',
                            }}
                            type="submit"
                        >
                            Save
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: 'steelblue',
                                color: 'white',
                                mt: '2vh',
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                    </Box>
                </form>
            </Paper>
            {
                loading && (
                    <LinearProgress sx={{ width: '99.5%', m: '0 auto' }} />
                )
            }
        </>
    );
};

export default DivisionForm;
